export default {
  "account": {
    "curatedCollections": "Colecciones curadas",
    "curatedCollectionsInfo": "Encuentra a continuación todas las colecciones que has comisariado",
    "editProfile": "Editar perfil",
    "likes": "Me gusta",
    "linkAccount": "Mi cuenta",
    "linkLogin": "Iniciar sesión",
    "linkLoginJoin": "Iniciar sesión/Unirse",
    "linkLogout": "Cerrar sesión",
    "myProfile": "Mi perfil",
    "notifications": {
      "loggedIn": "Ya ha iniciado la sesión. Bienvenido.",
      "loggedOut": "Ahora ha salido la sesión.",
      "noCollections": {
        "curated": "Todavía no has comisariado ninguna colección",
        "private": "Aún no has creado ninguna galería privada",
        "public": "Aún no has creado ninguna galería pública"
      },
      "noLikedItems": "Aún no le has dado \"Me gusta\" a ningún elementos"
    },
    "privateCollections": "Galerías privadas",
    "profile": "Mis \"Me gusta\" y galerías",
    "profileSettings": "Configuración de perfil",
    "publicCollections": "Galerías públicas",
    "settings": "Configuración",
    "title": "Mi cuenta"
  },
  "actions": {
    "accept": "Aceptar",
    "cancel": "Cancelar",
    "close": "cerrar",
    "continue": "continuar",
    "download": "Descargar",
    "edit": "Editar",
    "feedback": "Comentarios",
    "goBack": "Volver",
    "goHome": "Ir a la página de inicio",
    "learnMore": "Aprende más",
    "like": "Me gusta",
    "move": "Mover",
    "next": "próximo",
    "pin": "Alfiler",
    "preview": "Vista previa",
    "previous": "Anterior",
    "providedBy": "Proporcionado por {provider}",
    "reject": "Rechazar",
    "save": "Salvar",
    "send": "Enviar",
    "share": "Compartir",
    "shareOn": "Compartir en {social}",
    "skip": "Saltar",
    "viewAt": "Ver en {link}",
    "viewDocument": "Ver documento"
  },
  "attribution": {
    "country": "País:",
    "creator": "Creador:",
    "date": "Fecha:",
    "institution": "Institución:",
    "title": "Título:"
  },
  "automatedCardGroup": {
    "item": "Elementos recientes",
    "organisation": "Organizaciones",
    "place": "Lugares",
    "time": "Siglos destacados",
    "topic": "Temas destacados"
  },
  "blog": {
    "author": "Autor",
    "authors": "Autores",
    "blog": "Blog",
    "by": "por",
    "categories": "Categorías",
    "category": "Categoría",
    "posts": "Publicaciones del blog",
    "published": "Publicado el {date}",
    "relatedPosts": "Publicaciones relacionadas"
  },
  "cardLabels": {
    "organisation": "Organización",
    "person": "Persona",
    "place": "Lugar",
    "theme": "Tema",
    "time": "Siglo",
    "topic": "Tema"
  },
  "clearAllFilters": "borrar todos los filtros",
  "collections": {
    "actions": {
      "edit": "Editar colección",
      "update": "Actualizar colección"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "diseñadores",
          "name": "Diseñador | Diseñadores",
          "select": "Seleccionar diseñadores"
        },
        "proxy_dc_format": {
          "moreName": "técnicas",
          "name": "Técnica | Técnicas",
          "select": "Seleccionar técnicas"
        },
        "proxy_dc_type": {
          "moreName": "tipos de elementos",
          "name": "Tipo de objeto | Tipos de objeto",
          "select": "Seleccionar tipos de elementos"
        },
        "proxy_dcterms_medium": {
          "moreName": "materiales",
          "name": "Material | Materiales",
          "select": "Seleccionar materiales"
        }
      }
    },
    "form": {
      "description": "Descripción"
    },
    "notifications": {
      "update": "La colección se ha actualizado"
    }
  },
  "collectionsYouMightLike": "Colecciones que quizá te gusten",
  "colourSwatch": "Muestra de color",
  "contentYouMightLike": "Contenido que quizá te guste",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Más información",
      "about": "Acerca de Europeana",
      "forDevelopers": "Para desarrolladores",
      "help": "Ayuda",
      "meetUs": "Nuestro equipo",
      "provide": "Conviértete en proveedor de datos",
      "subscribe": "Suscríbete a nuestro boletín",
      "terms": "Condiciones de uso y Política de privacidad"
    },
    "headerNavigation": {
      "Collections": "Colecciones",
      "explore": "Explorar",
      "teachers": "Profesores"
    }
  },
  "curatedAutomatically": "Comisariados automáticamente por Europeana",
  "dateFilter": {
    "endDate": "Fecha de finalización",
    "specificDate": "Fecha concreta",
    "startDate": "Fecha de inicio",
    "to": "a"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Clave API de Europeana",
      "noRequests": "En esta página no se utilizaron solicitudes a las API de Europeana.",
      "settingsPageLinkText": "página de configuración",
      "tip": "Sugerencia: si ya tiene un {apiKeyLink}, puede ingresarlo en {settingsPageLink} y se incluirá en estos enlaces de solicitud de API.",
      "title": "Solicitudes de API"
    },
    "debug": "Depurar",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Introduzca su clave de API de Europeana y se utilizará en los enlaces a las solicitudes de API.",
          "label": "Clave API"
        },
        "enabled": {
          "description": "Si está habilitado, el menú de depuración se mostrará en el pie de página.",
          "label": "Habilitar menú de depuración"
        }
      },
      "title": "Configuración"
    }
  },
  "delete": "Borrar",
  "depiction": "Una representación de {title}",
  "directions": {
    "left": "Izquierda",
    "right": "Derecha"
  },
  "edmIsShownAtLinkAlt": "Ver en el sitio web del proveedor",
  "entity": {
    "actions": {
      "cancel": "Cancelar",
      "pin": "Elemento de pin",
      "unpin": "Desanclar elemento",
      "viewPinned": "Ver elementos anclados"
    },
    "labels": {
      "entity": "Entidad"
    },
    "notifications": {
      "deleted": "Tu galería ha sido eliminada.",
      "error": {
        "unpin": "Se ha producido un error al desanclar el elemento. Vuelva a intentarlo o informe del problema."
      },
      "pin": "Este elemento se mostrará en la parte superior de la colección \" {entity} \". Le notificaremos cuando este cambio sea visible en la página de colección.",
      "pinLimit": {
        "body": "Por ahora, solo puede anclar 24 elementos en la primera página. Si desea anclar este elemento, asegúrese de desanclar otro y luego intente anclar este de nuevo.",
        "title": "Demasiados elementos fijados"
      },
      "pinned": "El elemento se ha anclado. Ahora está en la parte superior de la primera página de esta colección. Puede tardar hasta 24 horas en aparecer para todos.",
      "select": "Seleccione una entidad relacionada para anclar/desanclar el elemento a/desde ella.",
      "unpin": "Este elemento dejará de mostrarse en la parte superior de la colección \" {entity} \". Le notificaremos cuando este cambio sea visible en la página de colección.",
      "unpinned": "El elemento se ha desanclarado. Ya no está en la parte superior de la primera página de esta colección. Puede tardar hasta 24 horas en desaparecer para todos."
    }
  },
  "error": "Error",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Esto no es posible porque las galerías privadas solo son visibles para su creador. Si conoce al creador de la galería, pídale que la haga pública. Alternativamente, informe este problema usando el botón de comentarios.",
      "metaTitle": "Galería no autorizada",
      "title": "¡Ups! {newline} Estás intentando ver la galería privada de otra persona."
    },
    "itemNotFound": {
      "description": "Esto podría deberse a las siguientes razones: este elemento no existe, o; fue des publicado porque no coincidía con nuestros criterios de calidad, o; se actualizó y se volvió a publicar con un nuevo identificador único, en cuyo caso, intente encontrar el elemento nuevamente.",
      "metaTitle": "Elemento no encontrado",
      "title": "¡Oh, no! {newline} No pudimos encontrar este elemento."
    }
  },
  "exhibitions": {
    "chapters": "Capítulos",
    "credits": "Créditos",
    "currentChapter": "Capítulo actual",
    "description": "Explora las exposiciones",
    "exhibitions": "Exposiciones"
  },
  "explore": "Explorar",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "colores",
      "name": "Color | Colores",
      "options": {
        "#000000": "Negro",
        "#000080": "Azul marino",
        "#00008B": "Azul oscuro",
        "#0000CD": "Azul medio",
        "#0000FF": "Azul",
        "#006400": "Verde oscuro",
        "#008000": "Web verde",
        "#008080": "Verde azulado",
        "#008B8B": "Cian oscuro",
        "#00BFFF": "Deep Sky Blue",
        "#00CED1": "Turquesa oscuro",
        "#00FA9A": "Medium Spring Green",
        "#00FF00": "Verde",
        "#00FF7F": "Primavera verde",
        "#00FFFF": "Cian",
        "#191970": "Azul medianoche",
        "#1E90FF": "Azul Dodger",
        "#20B2AA": "Light Sea Green",
        "#228B22": "Bosque verde",
        "#2E8B57": "Mar verde",
        "#2F4F4F": "Gris pizarra oscuro",
        "#32CD32": "Verde lima",
        "#3CB371": "Verde Mar Medio",
        "#40E0D0": "Turquesa",
        "#4169E1": "Azul real",
        "#4682B4": "Azul acero",
        "#483D8B": "Azul pizarra oscuro",
        "#48D1CC": "Turquesa medio",
        "#4B0082": "Índigo",
        "#556B2F": "Verde oliva oscuro",
        "#5F9EA0": "Azul cadete",
        "#6495ED": "Florecimiento de maíz",
        "#663399": "Rebecca Purple",
        "#66CDAA": "Aguamarina mediana",
        "#696969": "Gris tenue",
        "#6A5ACD": "Azul pizarra",
        "#6B8E23": "Gris aceituna",
        "#708090": "Pizarra gris",
        "#778899": "Gris pizarra claro",
        "#7B68EE": "Azul pizarra medio",
        "#7CFC00": "Verde césped",
        "#7F0000": "Web Maroon",
        "#7F007F": "Web morado",
        "#7FFF00": "Monasterio",
        "#7FFFD4": "Aguamarina",
        "#800000": "Granate",
        "#800080": "Púrpura",
        "#808000": "Aceituna",
        "#808080": "Web Grey",
        "#87CEEB": "Cielo azul",
        "#87CEFA": "Azul cielo claro",
        "#8A2BE2": "Violeta Azul",
        "#8B0000": "Rojo oscuro",
        "#8B008B": "Magenta oscuro",
        "#8B4513": "Marrón montura",
        "#8FBC8F": "Mar Verde Oscuro",
        "#90EE90": "Verde claro",
        "#9370DB": "Púrpura medio",
        "#9400D3": "Violeta oscuro",
        "#98FB98": "Verde pálido",
        "#9932CC": "Orquídea oscuro",
        "#9ACD32": "Amarillo verde",
        "#A020F0": "Púrpura",
        "#A0522D": "Siena",
        "#A52A2A": "marrón",
        "#A9A9A9": "Gris oscuro",
        "#ADD8E6": "Azul claro",
        "#ADFF2F": "Verde amarillo",
        "#AFEEEE": "Turquesa pálido",
        "#B03060": "Granate intenso",
        "#B0C4DE": "Azul acero claro",
        "#B0E0E6": "Azul pálido",
        "#B22222": "Ladrillo refractario",
        "#B8860B": "Dorado alambre oscuro",
        "#BA55D3": "Orquídea medio",
        "#BC8F8F": "Rosy Brown",
        "#BDB76B": "Caqui oscuro",
        "#BEBEBE": "Gris",
        "#C0C0C0": "Plata",
        "#C71585": "Violeta rojo medio",
        "#CD5C5C": "Rojo indio",
        "#CD853F": "Perú",
        "#D2691E": "Chocolate",
        "#D2B48C": "Bronceado",
        "#D3D3D3": "Gris claro",
        "#D8BFD8": "Cardo",
        "#DA70D6": "Orquídea",
        "#DAA520": "Vara de oro",
        "#DB7093": "Rojo Violeta Pálido",
        "#DC143C": "carmesí",
        "#DCDCDC": "Gainsboro",
        "#DDA0DD": "ciruela",
        "#DEB887": "Burlywood",
        "#E0FFFF": "Cian claro",
        "#E6E6FA": "Lavanda",
        "#E9967A": "Salmón oscuro",
        "#EE82EE": "Violeta",
        "#EEE8AA": "Vara de oro pálida",
        "#F08080": "Coral claro",
        "#F0E68C": "Caqui",
        "#F0F8FF": "Azul Alicia",
        "#F0FFF0": "Gotas de miel",
        "#F0FFFF": "Azur",
        "#F4A460": "Sandy Brown",
        "#F5DEB3": "Trigo",
        "#F5F5DC": "Beige",
        "#F5F5F5": "Humo blanco",
        "#F5FFFA": "Crema de menta",
        "#F8F8FF": "Fantasma blanco",
        "#FA8072": "Salmón",
        "#FAEBD7": "Blanco antiguo",
        "#FAF0E6": "Lino",
        "#FAFAD2": "Vara de oro claro",
        "#FDF5E6": "Encaje antiguo",
        "#FF0000": "rojo",
        "#FF00FF": "Fucsia",
        "#FF1493": "Rosa intenso",
        "#FF4500": "Rojo naranja",
        "#FF6347": "Tomate",
        "#FF69B4": "Rosa caliente",
        "#FF7F50": "Coral",
        "#FF8C00": "Naranja oscuro",
        "#FFA07A": "Salmón claro",
        "#FFA500": "naranja",
        "#FFB6C1": "Rosa claro",
        "#FFC0CB": "Rosado",
        "#FFD700": "Oro",
        "#FFDAB9": "Soplido melocotón",
        "#FFDEAD": "Navajo White",
        "#FFE4B5": "Mocasín",
        "#FFE4C4": "Sopa",
        "#FFE4E1": "Misty Rose",
        "#FFEBCD": "Almendra Blanqueada",
        "#FFEFD5": "Látigo de papaya",
        "#FFF0F5": "Rubor lavanda",
        "#FFF5EE": "Concha",
        "#FFF8DC": "Seda de maiz",
        "#FFFACD": "Gasa de limón",
        "#FFFAF0": "Blanco floral",
        "#FFFAFA": "Nieve",
        "#FFFF00": "Amarillo",
        "#FFFFE0": "Amarillo claro",
        "#FFFFF0": "Marfil",
        "#FFFFFF": "Blanco"
      },
      "select": "Seleccionar colores"
    },
    "COUNTRY": {
      "name": "País proveedor",
      "options": {
        "Albania": "Albania",
        "Austria": "Austria",
        "Belarus": "Bielorrusia",
        "Belgium": "Bélgica",
        "Bosnia and Herzegovina": "Bosnia y Herzegovina",
        "Bulgaria": "Bulgaria",
        "Croatia": "Croacia",
        "Cyprus": "Chipre",
        "Czech Republic": "República Checa",
        "Denmark": "Dinamarca",
        "Estonia": "Estonia",
        "Europe": "Europa",
        "Finland": "Finlandia",
        "France": "Francia",
        "Georgia": "Georgia",
        "Germany": "Alemania",
        "Greece": "Grecia",
        "Holy See (Vatican City State)": "Santa Sede (Estado de la Ciudad del Vaticano)",
        "Hungary": "Hungría",
        "Iceland": "Islandia",
        "Ireland": "Irlanda",
        "Israel": "Israel",
        "Italy": "Italia",
        "Latvia": "Letonia",
        "Lithuania": "Lituania",
        "Luxembourg": "Luxemburgo",
        "Macedonia": "Macedonia",
        "Malta": "Malta",
        "Moldova": "Moldavia",
        "Montenegro": "Montenegro",
        "Netherlands": "Países Bajos",
        "Norway": "Noruega",
        "Poland": "Polonia",
        "Portugal": "Portugal",
        "Romania": "Rumanía",
        "Russia": "Rusia",
        "Serbia": "Serbia",
        "Slovakia": "Eslovaquia",
        "Slovenia": "Eslovenia",
        "Spain": "España",
        "Sweden": "Suecia",
        "Switzerland": "Suiza",
        "Turkey": "Turquía",
        "Ukraine": "Ucrania",
        "United Kingdom": "Reino Unido",
        "United States of America": "Estados Unidos de América"
      },
      "select": "Seleccionar países proveedores"
    },
    "CREATOR": {
      "moreName": "creadores",
      "name": "Creador | Creadores",
      "select": "Seleccionar creadores"
    },
    "DATA_PROVIDER": {
      "moreName": "instituciones",
      "name": "Institución",
      "select": "Seleccionar instituciones"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Orientación de la imagen | Orientaciones de la imagen",
      "options": {
        "landscape": "Horizontal",
        "portrait": "Vertical"
      },
      "select": "Seleccionar orientaciones de imagen"
    },
    "IMAGE_SIZE": {
      "name": "Tamaño de imagen | Tamaños de imagen",
      "options": {
        "extra_large": "Extragrande, 4 MP o más (por ejemplo, 2688 × 1520 px) ",
        "large": "Grande, entre 1 y 4 MP (por ejemplo, 1920 × 1080 px)",
        "medium": "Mediano, entre 0,5 y 1 MP (por ejemplo 850 × 850 px)",
        "small": "Pequeño, inferior a 0,5 MP (por ejemplo, 650 × 600 px)"
      },
      "select": "Seleccionar tamaños de imagen"
    },
    "LANGUAGE": {
      "name": "Idioma",
      "options": {
        "ar": "Árabe",
        "bg": "Búlgaro",
        "bs": "Bosnio",
        "ca": "Catalán",
        "cs": "Checo",
        "cy": "Galés",
        "da": "Danés",
        "de": "Alemán",
        "el": "Griego",
        "en": "Inglés",
        "es": "Español",
        "et": "Estonio",
        "fi": "Finlandés",
        "fr": "Francés",
        "ga": "Irlandés",
        "gd": "Gaélico",
        "he": "Hebreo",
        "hr": "Croata",
        "hu": "Húngaro",
        "is": "Islandés",
        "it": "Italiano",
        "lt": "Lituano",
        "lv": "Letón",
        "mk": "Macedonio",
        "mt": "Maltés",
        "mul": "Múltiples idiomas",
        "nl": "Holandés",
        "no": "Noruego",
        "pl": "Polaco",
        "pt": "Portugués",
        "ro": "Rumano",
        "ru": "Ruso",
        "sk": "Eslovaco",
        "sl": "Esloveno",
        "sq": "Albanés",
        "sr": "Serbio",
        "sv": "Sueco",
        "tr": "Turco",
        "uk": "Ucraniano"
      },
      "select": "Seleccionar idiomas"
    },
    "MIME_TYPE": {
      "name": "Formato de archivo | Formatos de archivo",
      "options": {
        "text/plain": "Texto sin formato"
      },
      "select": "Seleccionar formatos de archivo"
    },
    "PROVIDER": {
      "moreName": "agregadores",
      "name": "Agregador",
      "select": "Seleccionar agregadores"
    },
    "REUSABILITY": {
      "name": "¿Puede reutilizarse?",
      "options": {
        "open": "Sí",
        "permission": "Tal vez, solicite permiso",
        "restricted": "Sí, con condiciones",
        "uncategorized": "Sin categoría"
      },
      "select": "Seleccione si puede usar esto"
    },
    "TYPE": {
      "name": "Tipo de medio",
      "options": {
        "3D": "3D",
        "IMAGE": "Imagen",
        "SOUND": "Sonido",
        "TEXT": "Texto",
        "VIDEO": "Vídeo"
      },
      "select": "Seleccionar tipos de medios"
    },
    "api": {
      "name": "Buscar",
      "options": {
        "fulltext": "Registros de texto completo",
        "metadata": "Registros de solo metadatos"
      },
      "switch": "Buscar solo en el contenido de los elementos con texto completo",
      "switchMoreInfo": "En esta colección, puede elegir lo que desea buscar: si este interruptor está activado, buscará dentro del periódico y el texto del documento; si está desactivada, buscará dentro de la información que describe el elemento, como siempre lo hace en la mayoría de las otras colecciones."
    },
    "button": {
      "apply": "Aplicar",
      "cancel": "Cancelar",
      "morefilters": "Más filtros",
      "reset": "Reiniciar",
      "showAll": "Mostrar todo {label}",
      "showLess": "Mostrar menos {label}"
    },
    "collection": {
      "name": "Tema",
      "options": {
        "archaeology": "Arqueología",
        "art": "Arte",
        "fashion": "Moda",
        "industrial": "Patrimonio industrial",
        "manuscript": "Manuscritos",
        "map": "Mapas y geografía",
        "migration": "Migración",
        "music": "Música",
        "nature": "Historia natural",
        "newspaper": "Periódicos",
        "photography": "Fotografía",
        "sport": "Deporte",
        "ww1": "Primera Guerra Mundial"
      },
      "select": "Selecciona un tema"
    },
    "contentTier": {
      "name": "Calidad del artículo",
      "options": {
        "*": "Incluir los elementos que no cumplan nuestros criterios de publicación",
        "0": "Mostrar solo los elementos que no cumplen con nuestros criterios de publicación",
        "1": "Baja calidad",
        "2": "Calidad media",
        "3": "Alta calidad y reutilizable con condiciones",
        "4": "Alta calidad y libremente reutilizable"
      },
      "select": "Seleccione las calidades del artículo"
    },
    "moreOptions": "Busque para encontrar {0} más {1}.",
    "proxy_dc_format": {
      "name": "Formato | Formatos",
      "select": "Seleccionar formatos"
    },
    "proxy_dc_type": {
      "name": "Tipo | Tipos",
      "select": "Seleccionar tipos"
    },
    "proxy_dcterms_issued": {
      "name": "Fecha de publicación"
    },
    "proxy_dcterms_medium": {
      "name": "Medio | Medios",
      "select": "Seleccionar medios"
    }
  },
  "feedback": {
    "emailOptional": "Es posible que queremos hacer un seguimiento. Introduce tu correo electrónico si estás de acuerdo en que nos pongamos en contacto contigo.",
    "failed": "La solicitud falló. Inténtalo de nuevo.",
    "form": {
      "placeholders": {
        "email": "Ingrese su dirección de correo electrónico",
        "feedback": "Ingrese sus comentarios aquí"
      }
    },
    "policies": "Al continuar, usted acepta nuestro {0} y reconoce nuestro {1}.",
    "privacyPolicy": "Política de privacidad",
    "success": "Su comentario ha sido enviado.",
    "termsOfService": "Términos de servicio",
    "thankYou": "Gracias.",
    "title": "Enviar comentarios",
    "validEmail": "Introduzca una dirección de correo electrónico válida",
    "validFeedback": "Sus comentarios deben constar de 5 palabras como mínimo"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Contribuyentes",
      "dcCoverage": "Lugar-Fecha",
      "dcCreator": "Creador",
      "dcDate": "Fecha",
      "dcDescription": "Descripción",
      "dcDuration": "Duración",
      "dcFormat": "Formato",
      "dcIdentifier": "Identificador",
      "dcLanguage": "Idioma",
      "dcPublisher": "Editor",
      "dcRelation": "relaciones",
      "dcRights": "Derechos",
      "dcSource": "Fuente",
      "dcSubject": "Asunto",
      "dcTitle": "Título",
      "dcType": "Tipo de objeto",
      "dctermsCreated": "Fecha de creación",
      "dctermsExtent": "Alcance",
      "dctermsHasPart": "contiene",
      "dctermsHasVersion": "tiene una versión",
      "dctermsIsFormatOf": "es un formato de",
      "dctermsIsPartOf": "forma parte de",
      "dctermsIsReferencedBy": "es referenciado por",
      "dctermsIsReplacedBy": "es reemplazado por",
      "dctermsIsRequiredBy": "es requerido por",
      "dctermsIssued": "Fecha de edición",
      "dctermsMedium": "Mediano",
      "dctermsProvenance": "Procedencia",
      "dctermsReferences": "hace referencia a",
      "dctermsSpatial": "Lugares",
      "dctermsTOC": "Tabla de contenido",
      "dctermsTemporal": "Temporal",
      "edmCountry": "País proveedor",
      "edmCurrentLocation": "Ubicación actual",
      "edmDataProvider": "Institución proveedora",
      "edmHasMet": "ha conocido a",
      "edmIncorporates": "incorpora",
      "edmIntermediateProvider": "Proveedor intermediario",
      "edmIsDerivativeOf": "es derivado de",
      "edmIsRelatedTo": "Está relacionado con",
      "edmIsRepresentationOf": "es la representación de",
      "edmIsSimilarTo": "es parecido a",
      "edmIsSuccessorOf": "es el sucesor de",
      "edmProvider": "Proveedor",
      "edmRealizes": "Se da cuenta",
      "edmRights": "Licencia de los medios en este registro (a menos que se especifique lo contrario)",
      "edmUgc": "Contenido generado por el usuario",
      "europeanaCollectionName": "Nombre de la colección",
      "keywords": "Palabras clave (proporcionadas por la comunidad)",
      "timestampCreated": "Sello de creación",
      "timestampUpdate": "Sello de actualización",
      "wasPresentAt": "estuvo presente en",
      "year": "Año"
    },
    "webResource": {
      "about": "Acerca de RDF",
      "dcDescription": "Descripción",
      "ebucoreHasMimeType": "Tipo EBUCore MIME",
      "edmRights": "Licencia para este recurso multimedia",
      "rdfAbout": "RDF About"
    }
  },
  "filter": "Filtrar",
  "filterResults": "Filtrar resultados",
  "footer": {
    "customiseWebsiteLanguage": "Personalizar el idioma del sitio web",
    "disclaimerLine1": "Europeana es una iniciativa de la Unión Europea, financiada por el Connecting Europe Facility de la Unión Europea y los Estados miembros de la Unión Europea. Los servicios de Europeana, incluido este sitio web, son operados por un consorcio liderado por la Fundación Europeana en virtud de un contrato de servicios con la Comisión Europea.",
    "disclaimerLine2": "La Comisión Europea no garantiza la exactitud de la información y no acepta responsabilidad alguna con respecto a la información en este sitio web. Ni la Comisión Europea, ni ninguna persona que actúe en nombre de la Comisión Europea, es responsable de la exactitud o el uso de la información en este sitio web.",
    "findUsElsewhere": "Puedes encontrarnos también en",
    "imageDescription": "Financiado por la Unión Europea",
    "navigation": {
      "MoreInfoLabel": "Más información",
      "about": "¿Qué es Europeana?",
      "accessibility": "Accesibilidad",
      "cookies": "Cookies",
      "forDevelopers": "Para desarrolladores",
      "help": "Ayuda",
      "privacy": "Política de privacidad",
      "provide": "Conviértete en proveedor de datos",
      "subscribe": "Suscríbete a nuestro boletín",
      "terms": "Condiciones de uso"
    },
    "ourMission": "Nuestra misión",
    "ourMissionQuote": "Europeana sostiene el sector del patrimonio cultural en su transformación digital. Desarrollamos competencias, herramientas y estrategias para adoptar el cambio digital y fomentar colaboraciones que promuevan la innovación."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Explora nuestras galerías",
    "galleries": "Galerías"
  },
  "goToRecord": "Ir al registro",
  "header": {
    "backToMenu": "Cerrar cuadro de búsqueda",
    "clearQuery": "Borrar la consulta de búsqueda",
    "closeSidebar": "Cerrar Menú",
    "entireCollection": "Busca {query} en toda nuestra colección",
    "europeanaHome": "Página de inicio de Europeana",
    "inCollection": "Busca {query} en {collection}",
    "navigation": {
      "about": "¿Qué es Europeana?",
      "collections": "Colecciones",
      "europeanaClassroom": "Para profesores",
      "help": "Ayuda",
      "home": "Inicio",
      "pro": "Para los profesionales",
      "stories": "Historias"
    },
    "quickSearch": "Búsqueda rápida",
    "searchFor": "Busca {query}",
    "searchForEverything": "Busca lo que quieras",
    "searchForEverythingInCollection": "Busca lo que quieras en {collection}",
    "searchForEverythingInEntireCollection": "Busca lo que quieras en toda nuestra colección",
    "searchForm": "Formulario de búsqueda",
    "showSidebar": "Mostrar menú",
    "sideNavigation": "Navegación lateral"
  },
  "homeLinkAlt": "Página de inicio de Europeana",
  "homePage": {
    "discoverEditorial": "Últimas historias",
    "storiesCTA": "Ver todas las historias",
    "subHeadline": "Busca, guarda y comparte arte, libros, películas y música de miles de instituciones culturales",
    "themesCTA": "Ver todos los temas",
    "themesTitle": "Explorar por tema",
    "title": "Descubre el patrimonio cultural {digital} europeo",
    "titleDigital": "digital"
  },
  "imageSlider": {
    "handle": "Manipulador de control deslizante"
  },
  "items": {
    "itemCount": "1 elemento | {count} elementos",
    "itemOf": "{max} de {count} elementos",
    "recent": "Elementos recientes",
    "recommended": "Elementos recomendados",
    "youMightLike": "Elementos que quizá te gusten"
  },
  "klaro": {
    "main": {
      "acceptAll": "Aceptar todo",
      "acceptSelected": "Aceptar seleccionado",
      "consentModal": {
        "description": "Nos tomamos muy en serio la privacidad de sus datos. Aquí puede evaluar y personalizar los servicios que nos gustaría utilizar en este sitio web. ¡Estás a cargo! Habilite o deshabilite los servicios como mejor le parezca.",
        "title": "Servicios que nos gustaría utilizar."
      },
      "consentNotice": {
        "description": "Nos preocupamos por su privacidad y solo usamos los datos para mejorar su experiencia. No utilizamos ninguna información personal para publicidad. Puede cambiar su consentimiento cada 15 días.",
        "learnMore": "Dejame elegir"
      },
      "decline": "Me niego",
      "ok": "Okey",
      "purposes": {
        "essential": {
          "description": "Estos servicios son imprescindibles para el correcto funcionamiento de este sitio web. Incluyen vista de resultados de búsqueda y preferencias de idioma, preservan el estado de inicio de sesión y mantienen su visita segura. No puede deshabilitarlos ya que el sitio web no funcionaría correctamente de otra manera.",
          "title": "Servicios esenciales para la seguridad y la personalización"
        },
        "usage": {
          "description": "Estos servicios recopilan la información para ayudarnos a comprender mejor cómo se usa el sitio web y dónde están los puntos débiles, lo que nos permite tomar decisiones informadas para mejorar su experiencia.",
          "title": "Servicios para capturar el uso y los comentarios del sitio web"
        }
      },
      "service": {
        "disableAll": {
          "description": "Utilice este interruptor para habilitar o deshabilitar todos los servicios opcionales.",
          "title": "Habilitar o deshabilitar todos los servicios"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Ayuda a mejorar nuestro sitio web aplicando ocasionalmente cambios experimentales.",
        "title": "Pruebas A/B"
      },
      "auth-strategy": {
        "description": "Recuerda la estrategia de autorización que se debe utilizar para iniciar sesión.",
        "title": "Estrategia de autenticación"
      },
      "debugSettings": {
        "description": "Ayuda a depurar solicitudes de API",
        "title": "Alternar depuración"
      },
      "hotjar": {
        "description": "Activa un widget de encuesta que le brinda la opción de responder a nuestras encuestas de satisfacción de visitantes.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Recuerda su idioma de interfaz preferido para acceder en el futuro.",
        "title": "Código de la lengua"
      },
      "jira-servicedesk": {
        "description": "Activa el widget de comentarios que le da la opción de contactarnos.",
        "title": "Mesa de servicio Jira"
      },
      "matomo": {
        "description": "Recopila estadísticas anónimas sobre cómo los visitantes interactúan con el sitio web.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Muestra una notificación cuando hay nuevas funciones disponibles.",
        "title": "Notificación de nuevas funciones"
      },
      "searchResultsView": {
        "description": "Recuerda si prefiere ver los resultados de la búsqueda en una vista de lista o cuadrícula.",
        "title": "Vista de resultados de búsqueda (lista / cuadrícula)"
      }
    }
  },
  "layout": {
    "skipToMain": "Saltar al contenido de la página"
  },
  "learnMore": "Más información de la fuente de esta descripción",
  "loading": "Cargando",
  "loadingResults": "Cargando resultados",
  "messages": {
    "copyToClipboardSuccess": "Copiado en el portapapeles",
    "externalContentError": "El contenido externo no se ha podido cargar",
    "notFound": "No se ha encontrado",
    "paginationLimitExceeded": "Solo es posible ver los primeros {limit} resultados de búsqueda."
  },
  "modal": {
    "download": {
      "clickToCopy": "Haga clic en la atribución para copiarla",
      "modalIntro": "Si usa este elemento en la web o en otro lugar, no olvide mostrar la siguiente atribución junto a él:",
      "modalTitle": "Di gracias"
    }
  },
  "multilingual": {
    "automated": "Traducción automática",
    "enrichment": "Enriquecimiento por parte de proyectos asociados",
    "other": "otros idiomas",
    "stopTranslating": "Dejar de traducir este elemento a {0}.",
    "translateLanguage": "¿Le gustaría ver este artículo en {0} ?",
    "translateQuotaError": "El servicio de traducción no está disponible temporalmente. Por favor, inténtelo de nuevo más tarde."
  },
  "newFeatureNotification": {
    "dismiss": "Cerrar",
    "readMore": "Leer más",
    "text": {
      "searchFilters": "Ahora puede buscar valores en los filtros individuales; ¡Echale un vistazo!"
    }
  },
  "newWindow": "se abre en una nueva ventana",
  "noMoreResults": "No hay más resultados para su búsqueda.",
  "noResults": "No hay resultados",
  "of": "De",
  "organisation": {
    "city": "Ciudad",
    "country": "País",
    "englishName": "Nombre en inglés",
    "nameAcronym": "acrónimo del nombre"
  },
  "pageHasLoaded": "ha cargado",
  "pageNumber": "Número de página",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Nombre"
        },
        "title": "Organizaciones"
      },
      "persons": {
        "title": "Personas"
      },
      "places": {
        "title": "Lugares"
      },
      "table": {
        "items": "Elementos",
        "name": "Nombre"
      },
      "times": {
        "title": "Veces"
      },
      "topics": {
        "title": "Temas"
      }
    }
  },
  "pagination": {
    "label": "Paginación"
  },
  "readMore": "Leer más",
  "recommendation": {
    "prompts": {
      "accept": "Pulgar arriba para agregar a la galería",
      "reject": "Pulgar hacia abajo si no le gusta"
    }
  },
  "record": {
    "IIIFViewer": "Visor IIIF",
    "actions": {
      "pin": "Anclar elemento a entidades disponibles"
    },
    "allMetaData": "Todos los metadatos",
    "copyEmbedLabel": "Código de inserción (haga clic para copiar)",
    "exploreMore": "Explorar más",
    "extendedInformation": "Información ampliada",
    "goodToKnow": "Información importante",
    "hideAll": "Ocultar toda la información",
    "location": "Ubicación",
    "locationOnMap": "Ubicación en el mapa",
    "mediaPlayer": "Reproductor multimedia",
    "record": "Registro",
    "showAll": "Mostrar toda la información",
    "similarItems": "Elementos similares",
    "status": {
      "unpublished": "[Artículo no publicado]"
    },
    "transcription": "Transcripción",
    "transcriptionDisclaimer": "Este contenido ha sido aportado por el público, no por la institución que ha proporcionado este artículo."
  },
  "related": {
    "editorial": {
      "title": "Historias que te pueden gustar"
    }
  },
  "relatedCollections": "Colecciones relacionadas",
  "removeFilter": "Quitar el filtro {filterLabel}",
  "reset": "Reiniciar",
  "resourceWikimedia": "Recurso de Wikimedia Commons",
  "results": "Resultados",
  "resultsFor": "Resultados para {0}",
  "resultsLimitWarning": "No se muestran los resultados adicionales, ya que solo se muestran los primeros 1000 resultados más relevantes. Si no ha encontrado lo que está buscando, considere delimitar su búsqueda.",
  "resultsWithin": "Resultados dentro de {0} {1} para {2}",
  "search": {
    "boost": {
      "placeholder": "Introduzca la consulta de refuerzo del campo"
    },
    "title": "Buscar"
  },
  "searchHasLoaded": "{0} resultados devueltos",
  "searchPlaceholder": "Buscar más de 50 millones de objetos",
  "searchResults": "Buscar",
  "searchResultsFor": "{0} - Buscar",
  "searchSuggestions": "Sugerencias de búsqueda",
  "searchTier": {
    "button": {
      "hide": "Ocultar estos elementos",
      "show": "Mostrar estos elementos"
    },
    "text": {
      "hide": "Se muestran los elementos que no cumplen nuestros criterios de publicación.",
      "show": "Hay más elementos que coinciden con su búsqueda, pero no cumplen nuestros criterios de publicación."
    }
  },
  "searchViews": {
    "grid": "Ver en cuadrícula",
    "list": "Ver en lista",
    "mosaic": "Vista de mosaico"
  },
  "set": {
    "actions": {
      "addTo": "Agregar a la galería",
      "create": "Crear galería",
      "createNew": "Crear nueva galería",
      "delete": "Eliminar galería",
      "edit": "Editar galería",
      "update": "Actualizar galería"
    },
    "form": {
      "description": "Descripción de la galería",
      "private": "Mantener esta galería como privada",
      "required": "Campos obligatorios",
      "title": "Nombre de la galería"
    },
    "labels": {
      "curatedBy": "Comisariados por",
      "private": "Galería privada"
    },
    "notifications": {
      "deleted": "Tu galería ha sido eliminada.",
      "likeLimit": {
        "body": "Lo sentimos, pero en este momento el límite de \"Me gusta\" está establecido en un máximo de 100 artículos. ¡Pronto eliminaremos este límite!",
        "title": "100 \"Me gusta\""
      },
      "updated": "El elemento se agregó a la galería."
    },
    "prompts": {
      "delete": "¿Estás seguro de que quieres eliminar esta galería? Si eliminas esta galería, perderás todos los elementos que le hayas agregado."
    }
  },
  "showLess": "Mostrar menos",
  "showMore": "Mostrar más",
  "sideFilters": {
    "noOptions": "No hay opciones disponibles para seleccionar",
    "search": "Buscar"
  },
  "statuses": {
    "liked": "Gustó",
    "pinned": "Fijado"
  },
  "storiesPage": {
    "title": "Historias"
  },
  "website": "Sitio web",
  "youMightAlsoLike": "También podría gustarte"
};
